<template>
  <div class="add-container" v-loading="formLogicLoading">
    <div>
      <el-page-header :content="`${ruleId ? '编辑' : '新增'}行动规则`" class="mb-10 fw-bold" @back="goBack">
      </el-page-header>
    </div>
    <!-- 基本设置 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">基本设置</span>
      </div>
      <el-form ref="formLogic" :model="formLogic" :rules="workLogicRule" label-width="100px">
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="formLogic.name" style="width: 35%"></el-input>
        </el-form-item>
        <dt-form-item
          class="formkey-item"
          prop="formKey"
          :label="searchParamFormKey.label"
          :inputType="searchParamFormKey.type"
          v-model="formLogic.formKey"
          :propKey="searchParamFormKey.propKey"
          :options="searchParamFormKey.options"
          :componentAttr="searchParamFormKey.attrs"
          :valueRepeat="searchParamFormKey.valueRepeat"
        >
        </dt-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" :rows="4" v-model="formLogic.description" style="width: 35%"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 触发条件 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">触发条件</span>
        <el-button style="float: right" type="primary" @click="handleClickAddLogic">新增条件 </el-button>
      </div>
      <logic-form
        ref="logicForm"
        v-if="formLogic.formKey"
        :formKey="formLogic.formKey"
        :conditionList="conditionList"
      />
    </el-card>
    <!-- 生成工单 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">生成工单</span>
      </div>
      <el-form ref="triggerForm" :model="triggerList" :inline="true" :rules="triggerFormRule">
        <div class="mb-10">第一处理人</div>
        <el-row>
          <el-form-item>
            <span>选择处理人 </span>
            <el-select
              v-model="triggerList.firstProcessorType"
              @change=";(triggerList.firstProcessorId = []), firstProcessorTypeChange()"
            >
              <el-option label="门店角色" value="role" />
              <el-option label="指定用户" value="user" />
            </el-select>
          </el-form-item>
          <el-form-item prop="firstProcessorId">
            <el-select v-model="triggerList.firstProcessorId" multiple collapse-tags filterable>
              <el-option
                v-for="option in firstProcessorOptions"
                :key="option.id"
                :label="option.name || option.roleName"
                :value="option.id"
              />
            </el-select>
            <span style="color: #ccc"> 如果选择的角色包含多人，则指定其中任意一人处理</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <span>处理人为空时 </span>
            <el-select v-model="triggerStatus" @change="handleChangeTriggerStatus">
              <el-option label="系统关闭工单" value="close" />
              <el-option label="转交第二处理人" value="transmit" />
            </el-select>
          </el-form-item>
        </el-row>
        <template v-if="triggerStatus === 'transmit'">
          <div class="mb-10">第二处理人</div>
          <el-row>
            <el-form-item>
              <span>选择处理人 </span>
              <el-select
                v-model="triggerList.secondProcessorType"
                @change=";(triggerList.secondProcessorId = []), secondProcessorTypeChange()"
              >
                <el-option label="门店角色" value="role" />
                <el-option label="指定用户" value="user" />
              </el-select>
            </el-form-item>
            <el-form-item prop="secondProcessorId">
              <el-select v-model="triggerList.secondProcessorId" multiple collapse-tags filterable>
                <el-option
                  v-for="option in secondProcessorOptions"
                  :key="option.id"
                  :label="option.name || option.roleName"
                  :value="option.id"
                />
              </el-select>
            </el-form-item>
            <div>处理人为空时 系统关闭工单</div>
          </el-row>
        </template>
      </el-form>
    </el-card>
    <div class="detail-footer">
      <el-button size="mini" type="primary" plain @click="goBack"> 取消 </el-button>
      <el-button
        size="mini"
        v-re-click
        type="primary"
        @click="saveOrderRuleConfirm"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getWorkOrderLogicDetail,
  updateWorkOrderLogic,
  createWorkOrderLogic,
  querySimpleUserList
} from '@/api/workOrder/rule'
import { getRoleListAll } from '@/api/mange/role'
import { searchParamFormKey } from '../input'
import LogicForm from '@/components/LogicForm'

export default {
  components: { LogicForm },
  data() {
    const validateFormKey = (rule, value, callback) => {
      if (this.formLogic.formKey == '') {
        callback(new Error('请选择触发问卷'))
      } else {
        callback()
      }
    }

    return {
      ruleId: '',
      triggerStatus: 'close',
      workLogicRule: {
        name: [{ required: true, message: '请填写规则名称', trigger: ['blur', 'change'] }],
        formKey: [
          { required: true, message: '请选择触发问卷', trigger: ['blur', 'change'], validator: validateFormKey }
        ]
      },
      triggerFormRule: {
        firstProcessorId: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'blur'
          }
        ],
        secondProcessorId: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'blur'
          }
        ]
      },
      triggerList: {
        firstProcessorType: '',
        secondProcessorType: '',
        firstProcessorId: [],
        secondProcessorId: []
      },
      conditionList: [],
      searchParamFormKey,
      userAllData: [],
      roleAllData: [],
      firstProcessorOptions: [],
      secondProcessorOptions: [],
      formLogic: {
        name: '',
        formKey: '',
        description: ''
      },
      fullscreenLoading: false,
      formLogicLoading: false
    }
  },
  filters: {},
  watch: {
    'formLogic.formKey'(val) {
      if (!val) this.conditionList = []
    }
  },

  async created() {
    this.formLogicLoading = true
    await this.getRoleList()
    await this.getUserList()
    const { id } = this.$route.query
    this.ruleId = id
    if (id) this.getDetail(id)
    else this.formLogicLoading = false
  },

  methods: {
    handleClickAddLogic() {
      if (!this.formLogic.formKey) {
        this.$message.warning('请先选择触发问卷')
        return false
      }
      this.$refs.logicForm.addLogicHandle()
    },
    getUserList() {
      return new Promise((resolve, reject) => {
        querySimpleUserList()
          .then((res) => {
            if (res.data) {
              this.userAllData = res.data
            }
            resolve()
          })
          .catch((err) => {
            this.formLogicLoading = false
            reject(err)
          })
      })
    },
    getRoleList() {
      return new Promise((resolve, reject) => {
        getRoleListAll()
          .then((res) => {
            if (res.data) {
              this.roleAllData = res.data
            }
            resolve()
          })
          .catch((err) => {
            this.formLogicLoading = false
            reject(err)
          })
      })
    },
    firstProcessorTypeChange(val) {
      const { roleAllData, userAllData, triggerList } = this
      this.triggerFormRule.firstProcessorId[0].message = `请选择${val === 'role' ? '角色' : '用户'}`
      this.firstProcessorOptions = triggerList.firstProcessorType === 'role' ? roleAllData : userAllData
    },
    secondProcessorTypeChange(val) {
      const { roleAllData, userAllData, triggerList } = this
      this.triggerFormRule.secondProcessorId[0].message = `请选择${val === 'role' ? '角色' : '用户'}`
      this.secondProcessorOptions = triggerList.secondProcessorType === 'role' ? roleAllData : userAllData
    },
    handleChangeTriggerStatus(val) {
      if (val === 'close') {
        this.triggerList.secondProcessorType = ''
        this.triggerList.secondProcessorId = []
      }
    },
    async getDetail(id) {
      try {
        const { data } = await getWorkOrderLogicDetail(id)
        this.formLogic = data
        this.triggerList = data.triggerList
        this.conditionList = data.conditionList
        // 处理人数据处理
        const { firstProcessorType, secondProcessorType } = data.triggerList
        this.firstProcessorTypeChange(firstProcessorType)
        this.triggerStatus = secondProcessorType ? 'transmit' : 'close'
        if (secondProcessorType) this.secondProcessorTypeChange(secondProcessorType)
      } finally {
        this.formLogicLoading = false
      }
    },
    async checkTriggerList() {
      let valid = false
      await this.$refs.triggerForm.validate((valid) => {
        return valid
      })
    },
    // 保存行动规则
    saveOrderRuleConfirm() {
      const formLogicValid = new Promise((resolve, reject) => {
        this.$refs.formLogic.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
      const triggerListvalid = new Promise((resolve, reject) => {
        this.$refs.triggerForm.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })

      Promise.all([formLogicValid, triggerListvalid]).then(() => {
        const conditionList = this.$refs.logicForm?.logicList
        if (conditionList.length == 0) {
          this.$message.warning('触发条件至少包含一项')
          return false
        }
        this.fullscreenLoading = true
        const { ruleId, formLogic, triggerList } = this
        console.log({ formLogic, triggerList, conditionList })
        const fn = ruleId ? updateWorkOrderLogic : createWorkOrderLogic
        const params = { ...formLogic, conditionList, triggerList }
        fn(params)
          .then((res) => {
            if (res.code == 200) {
              this.fullscreenLoading = false
              this.$message.success('添加成功')
              this.goBack()
            }
          })
          .catch(() => {
            this.fullscreenLoading = false
          })
      })
    },
    goBack() {
      this.$router.replace('/workOrder/rule')
    }
  }
}
</script>
<style scoped>
.detail-footer {
  width: 80%;
  text-align: center;
  margin-top: 40px;
}
.add-container {
  padding: 20px;
  background: #fff;
  height: 100vh;
}
.box-card {
  width: 80%;
  margin-bottom: 10px;
}
::v-deep .formkey-item .dt-form-item-input {
  width: 35%;
}
</style>
